import { Component, OnInit } from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { InvoicePatientCashDeskService } from "../../../services/invoice-cash-desk/invoice-patient-cash-desk.service";

@Component({
  selector: 'invoice-patient-cash-desk-edit',
  templateUrl: './invoice-patient-cash-desk-edit.component.html',
  styleUrls: ['./invoice-patient-cash-desk-edit.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCashDeskService }]
})
export class InvoicePatientCashDeskEditComponent implements OnInit {

  ngOnInit(): void {

  }

  close(): void {
    history.back();
  }
}
